export default "__VITE_ASSET__B8Ki5Jle__"